<template>
  <a
    :href="url"
    rel="noopener"
    target="_blank"
    class="link link--external"
    :data-tealium-rel="dataTealium"
    @click="handleClick"
    ><slot />
    <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span>
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    notify: {
      type: Boolean,
      default: false,
    },
    tealiumName: { type: String, default: '' },
    tealiumSuffix: { type: String, default: '' },
    linkType: {
      type: String,
      default: 'button',
      validator: (value) => ['button', 'text'].includes(value),
    },
  },
  computed: {
    dataTealium() {
      if (
        (!this.tealiumName && this.tealiumSuffix) ||
        (this.tealiumName && !this.tealiumSuffix) ||
        (!this.tealiumName && !this.tealiumSuffix)
      )
        return '';
      return `content.${this.linkType}.${this.tealiumName}.${this.tealiumSuffix}`;
    },
  },
  methods: {
    handleClick(e) {
      const storage =
        typeof navigator !== 'undefined' &&
        typeof localStorage !== 'undefined' &&
        localStorage !== null
          ? localStorage
          : undefined;
      // skip, when local storage is not available!
      if (!this.notify || !storage) return;
      e.preventDefault();
      storage.setItem('redirectUrl', this.url);
      window.open('/redirecting', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped></style>
